export namespace EpicNavBarStates {
    export function factory() {
        const epicNavBar = {
            selected: -1,
            burgerMenuVisible: false,
            timestamp: new Date()
        };
        return epicNavBar;
    }

    export function mutations() {
        return {
            invokeEpicBurger(state: any) {
                state.epicNavBar.burgerMenuVisible = true;
                state.epicNavBar.timestamp = new Date();
            },
            sleepEpicrBurger(state: any) {
                state.epicNavBar.burgerMenuVisible = false;
                state.epicNavBar.timestamp = new Date();
            },
            epicNavTo(state: any, selected: number) {
                state.epicNavBar.selected = selected;
                state.epicNavBar.timestamp = new Date();
            },
        };
    }
}
